module.exports = __webpack_public_path__ + "media/img/uploads/logo-peo-avn-9829007f0d0a2d0c3e92a1bf25bdeaf3.png";